import React, { Fragment, useEffect, useState } from "react";
import { CCollapse, CLink } from "@coreui/react";
import Loader from "../Loader/Loader";
import axios from "axios";
import config from "../../config/config";
import { toastSuccess, toastError } from "../../common/Toast";
import { ERROR_MESSAGE, SUCCESS_MESSAGE } from "../../common/Constant";
import { AWS_IMAGE_FOLDER_FOOTERTOP } from "../../common/Constant";
import { uploadAWS } from "../../common/AWSHelper";
import noimage from "../../assets/img/noimgicon.png";

function TopFooter({ visibleTopNavigationChange, dynamicModule }) {
  const [visibleTopNav, setVisibleTopNav] = useState(false);
  const [loading, setLoading] = useState(false);
  const [topNav, setTopNav] = useState(visibleTopNavigationChange);
  const token = localStorage.getItem("Token");

  const [formValues, setFormValues] = useState({
    firstIcon: "",
    firstMainContent: "",
    firstSubContent: "",
    secondIcon: "",
    secondMainContent: "",
    secondSubContent: "",
    thirdIcon: "",
    thirdMainContent: "",
    thirdSubContent: "",
    forthIcon: "",
    forthMainContent: "",
    forthSubContent: "",
  });

  console.log(noimage, "noimagenoimagenoimage98798798");

  async function getTopFooterDetails() {
    try {
      const response = await axios.get(
        `${config.ecommconfigBaseUrl}/ecomconfig/commonconfigvalues?configtype=TopFooter&from=${dynamicModule}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      );

      const getApiData = response.data.ResponseData;

      const updatedFormValues = {
        firstIcon:
          getApiData.find((el) => el.CommonConfigKey === "first-icon")
            ?.CommonConfigValue || "",
        firstMainContent:
          getApiData.find((el) => el.CommonConfigKey === "first-main-content")
            ?.CommonConfigValue || "",
        firstSubContent:
          getApiData.find((el) => el.CommonConfigKey === "first-sub-content")
            ?.CommonConfigValue || "",
        secondIcon:
          getApiData.find((el) => el.CommonConfigKey === "second-icon")
            ?.CommonConfigValue || "",
        secondMainContent:
          getApiData.find((el) => el.CommonConfigKey === "second-main-content")
            ?.CommonConfigValue || "",
        secondSubContent:
          getApiData.find((el) => el.CommonConfigKey === "second-sub-content")
            ?.CommonConfigValue || "",
        thirdIcon:
          getApiData.find((el) => el.CommonConfigKey === "third-icon")
            ?.CommonConfigValue || "",
        thirdMainContent:
          getApiData.find((el) => el.CommonConfigKey === "third-main-content")
            ?.CommonConfigValue || "",
        thirdSubContent:
          getApiData.find((el) => el.CommonConfigKey === "third-sub-content")
            ?.CommonConfigValue || "",
        forthIcon:
          getApiData.find((el) => el.CommonConfigKey === "forth-icon")
            ?.CommonConfigValue || "",
        forthMainContent:
          getApiData.find((el) => el.CommonConfigKey === "forth-main-content")
            ?.CommonConfigValue || "",
        forthSubContent:
          getApiData.find((el) => el.CommonConfigKey === "forth-sub-content")
            ?.CommonConfigValue || "",
      };

      setFormValues(updatedFormValues);
    } catch (error) {
      console.error("Error fetching Top Footer data:", error);
    }
  }

  useEffect(() => {
    getTopFooterDetails();
  }, [dynamicModule]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log("Updating Top Footer data:", formValues);
    const data = {
      firstIcon: formValues.firstIcon,
      firstMainContent: formValues.firstMainContent,
      firstSubContent: formValues.firstSubContent,
      secondIcon: formValues.secondIcon,
      secondMainContent: formValues.secondMainContent,
      secondSubContent: formValues.secondSubContent,
      thirdIcon: formValues.thirdIcon,
      thirdMainContent: formValues.thirdMainContent,
      thirdSubContent: formValues.thirdSubContent,
      forthIcon: formValues.forthIcon,
      forthMainContent: formValues.forthMainContent,
      forthSubContent: formValues.forthSubContent,
      from: dynamicModule,
    };
    console.log("Updating Top Footer das:", data);

    setLoading(true);

    axios
      .post(`${config.ecommconfigBaseUrl}/ecomconfig/topfooterupsert`, data, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          // toastError("Email" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleImageChange = async (event, key) => {
    const file = event.target.files[0];
    console.log("Updating Top Footer data1:", file);

    if (file) {
      try {
        setLoading(true);
        await uploadAWS(file, AWS_IMAGE_FOLDER_FOOTERTOP, (data) => {
          console.log(data, "imageUrl");
          console.log(key, "imageUrl1");
          setFormValues((prevValues) => ({ ...prevValues, [key]: data }));
          console.log(formValues, "imageUrl11"); // Note: This may log the old state
        });
        console.log(formValues, "imageUrl111"); // This may also log the old state
      } catch (error) {
        console.error("Error uploading file:", error);
        toastError(ERROR_MESSAGE);
      } finally {
        setLoading(false);
      }
    }
  };

  // const renderRow = (iconKey, mainContentKey, subContentKey) => (
  //   <div className="row">
  //     <div className="col-4">
  //       <label>{iconKey}</label>
  //      <input
  //         type="file"
  //         src={formValues[iconKey]}
  //         className="form-control"
  //         onChange={(e) => handleImageChange(e, iconKey)}
  //       />

  //       <img
  //           src={noimage}
  //           // alt={`${iconKey}-preview`}
  //           style={{ width: "100px", height: "100px", marginTop: "10px" }}
  //         />

  //       {formValues[iconKey] && (
  //         <img
  //           src={formValues[iconKey]}
  //           alt={`${iconKey}-preview`}
  //           style={{ width: "100px", height: "100px", marginTop: "10px" }}
  //         />
  //       )}
  //     </div>
  //     <div className="col-4">
  //       <label>{mainContentKey}</label>
  //       <input
  //         className="form-control"
  //         name={mainContentKey}
  //         value={formValues[mainContentKey]}
  //         onChange={handleChange}
  //         placeholder={`Enter ${mainContentKey}`}
  //       />
  //     </div>
  //     <div className="col-4">
  //       <label>{subContentKey}</label>
  //       <input
  //         className="form-control"
  //         name={subContentKey}
  //         value={formValues[subContentKey]}
  //         onChange={handleChange}
  //         placeholder={`Enter ${subContentKey}`}
  //       />
  //     </div>
  //   </div>
  // );

  const renderRow = (iconKey, mainContentKey, subContentKey) => (
    <div
      style={{ border: "1px solid #ababab", borderRadius: "10px" }}
      className="row align-items-center mb-4"
    >
      <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 text-center">
        <input
          type="file"
          id={`file-input-${iconKey}`}
          accept="image/*"
          onChange={(e) => handleImageChange(e, iconKey)}
          style={{ display: "none" }}
        />

        <label
          htmlFor={`file-input-${iconKey}`}
          style={{
            cursor: "pointer",
            display: "flex",
            gap: "20px",
            alignItems: "center",
          }}
        >
          <img
            src={formValues[iconKey] || noimage}
            alt="Upload Icon"
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #ccc",
              backgroundColor: "#f5f5f5",
            }}
          />
          <div className="mt-2">
            <strong>Upload Profile Image</strong>
            <div style={{ fontSize: "12px", color: "#666" }}>
              Image should be below 500 kb
            </div>
          </div>
        </label>
      </div>

      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
        <label>{mainContentKey}</label>
        <input
          className="form-control"
          name={mainContentKey}
          value={formValues[mainContentKey]}
          onChange={handleChange}
          placeholder={`Enter ${mainContentKey}`}
        />
      </div>

      <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-5 col-sm-5 col-12">
        <label>{subContentKey}</label>
        <input
          className="form-control"
          name={subContentKey}
          value={formValues[subContentKey]}
          onChange={handleChange}
          placeholder={`Enter ${subContentKey}`}
        />
      </div>
    </div>
  );

  return (
    <Fragment>
      <Loader loading={loading} />
      <div className="card">
        <div className="card-header">
          <h5 className="card-title">
            <CLink
              className="link"
              onClick={() => {
                setVisibleTopNav(!visibleTopNav);
                setTopNav(!topNav);
              }}
            >
              Top Footer Bar
            </CLink>
          </h5>
        </div>
        <CCollapse visible={visibleTopNav || visibleTopNavigationChange}>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="p-4">
                <h6 className="mb-3">Top Footer</h6>
                {renderRow("firstIcon", "firstMainContent", "firstSubContent")}
                {renderRow(
                  "secondIcon",
                  "secondMainContent",
                  "secondSubContent"
                )}
                {renderRow("thirdIcon", "thirdMainContent", "thirdSubContent")}
                {renderRow("forthIcon", "forthMainContent", "forthSubContent")}
                <div className="d-flex justify-content-center mt-4">
                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </CCollapse>
      </div>
    </Fragment>
  );
}

export default TopFooter;
